import {ApiRes} from '../../types/api'
import {API_URL, apiGetV1} from '../api'

export interface IUserPointHistory {
    user_id: string
    amount: number
    count: number
    created_at: string
    name: string
    tx_id?: number
}

export const getUserPointHistory = async (id): Promise<ApiRes<IUserPointHistory[]>> => {
    return await apiGetV1(API_URL, `admin/point/history/${id}`)
}
